var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"iconWrapper",staticClass:"card-chart-icons"},_vm._l((_vm.icons),function(factor,indexFac){return _c('div',{key:indexFac,staticClass:"icon-container",style:({ width: _vm.iconWidth})},[_c('img',{attrs:{"src":factor.image,"alt":factor.image}})])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a0cdc1a2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/diagnosis/card-chart-icons.vue
// module id = 2583
// module chunks = 50